export enum RouteLayout {
  Main = 'Main',
  Empty = 'Empty',
  HeaderOnly = 'HeaderOnly',
}
